export const SelectBoxArrowDown = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.8656 8.35464L19.6148 8.12371C19.4356 7.95876 19.1848 7.95876 19.0056 8.12371L12.0179 14.5567L4.9944 8.12371C4.81523 7.95876 4.56439 7.95876 4.38522 8.12371L4.13438 8.35464C3.95521 8.51959 3.95521 8.75052 4.13438 8.91546L11.6954 15.8763C11.8746 16.0412 12.1254 16.0412 12.3046 15.8763L19.8656 8.91546C20.0448 8.75052 20.0448 8.51959 19.8656 8.35464Z"
      fill="#292B29"
    />
  </svg>
);
